export const STALE_TIME = {
  LOW: 5000,
  MEDIUM: 10000,
  HIGH: 20000,
  HIGHEST: 60000,
}; // in milliseconds
